import React, { useState, useEffect } from "react";
import getSubscriptionDetails from "../../services/apiFunctions";
import { organisationSubsDetails } from "../../services/apiFunctions";
import "./billing.css";
import Swal from "sweetalert2";
import axios from "axios";

import {
  getUserId,
  SubscriptionNormal,
  HEADERS,
  SubscriptionUpgrade,
  NormalVerifyOTP,
  UpgradeVerifyOTP,
} from "../api";
import { VerifiedUser } from "@mui/icons-material";
function Billing(props) {
  const [subscriptionPlan, setSubscriptionPlan] = useState(null);
  const [plans, setPlans] = useState([]);
  const [remainingTime, setRemainingTime] = useState({
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const padZero = (num) => String(num).padStart(2, "0");
  const userId = getUserId();

  useEffect(() => {
    const plan = localStorage.getItem("subscription_plan");
    const org_id = localStorage.getItem("organisation_id");

    console.log("organisation_id", org_id);
    setSubscriptionPlan(plan);
    const fetchOrganisationSubscription = async () => {
      try {
        const res = await organisationSubsDetails({ org_id });
        if (res?.response_code === "0000") {
          const { data } = res;
          setRemainingTime(data);
        } else {
          console.error("Failed to fetch subscription details:", res?.message);
        }
      } catch (err) {
        console.error("Error fetching organisation subscription details:", err);
      }
    };

    const fetchPlans = async () => {
      try {
        const res = await getSubscriptionDetails();
        if (res?.response_code === "0000") {
          const sortedPlans = res.data.sort((a, b) => {
            const order = ["free", "pro", "enterprise"];
            return (
              order.indexOf(a.plan_name.toLowerCase()) -
              order.indexOf(b.plan_name.toLowerCase())
            );
          });
          setPlans(sortedPlans);
        }
      } catch (err) {
        console.error("Failed to fetch subscription plans:", err);
      }
    };
    fetchPlans();
    const intervalId = setInterval(fetchOrganisationSubscription, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const getSubtitle = (name) => {
    switch (name.toLowerCase()) {
      case "free":
        return "Great for testing core features and getting started";
      case "pro":
        return "Best for small to medium-sized businesses looking for advanced features";
      case "enterprise":
        return "Best for large organizations with complex requirements.";
      default:
        return "";
    }
  };

  const getDurationDisplay = (plan) => {
    return plan.plan_name.toLowerCase() === "free" ? "(30 Days)" : "/year";
  };
  const handleSubscribe = async (plan) => {
    const { value: formValues } = await Swal.fire({
      html: `
      <div>
        <h5><strong>Subscribe to ${plan.plan_name} Plan</strong></h5>
        <span style="display: block; font-size:16px; text-align: left; margin-bottom: 5px;">
          DK Account Number
        </span>
        <input id="swal-account-number" class="form-control" placeholder="Enter 12-digit account number" maxlength="12">
      </div>
    `,
      preConfirm: () => {
        const accountNumber = document
          .getElementById("swal-account-number")
          .value.trim();
        if (!/^\d{12}$/.test(accountNumber)) {
          Swal.showValidationMessage(
            "Account number must be exactly 12 digits."
          );
          return false;
        }

        return { accountNumber };
      },
      confirmButtonText: "Subscribe",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      reverseButtons: true,
      confirmButtonColor: "#2D7D9F",
      focusConfirm: false,
    });

    if (formValues) {
      Swal.fire({
        title: "Please wait...",
        text: "Processing your subscription.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const { accountNumber } = formValues;
      const currentRank = getPlanRank(subscriptionPlan);
      const selectedRank = getPlanRank(plan.plan_name);

      try {
        let response;
        if (selectedRank === currentRank) {
          console.log(`Consuming SubscriptionNormal → plan: ${plan.plan_name}`);

          const requestBody = {
            plan_price: plan.plan_price.toString(),
            account_number: accountNumber,
          };

          try {
            const response = await axios.post(
              SubscriptionNormal,
              JSON.stringify(requestBody),
              { headers: HEADERS }
            );

            if (response?.data?.response_code === "0000") {
              console.log("res", response);
              const { plan_price, account_number, trans_id } =
                response?.data?.data || {};

              if (!plan_price || !account_number || !trans_id) {
                Swal.fire({
                  icon: "error",
                  title: "Missing Data",
                  text: "Required data missing from server response.",
                  confirmButtonColor: "#2D7D9F",
                });
                return;
              }

              const { value: otp } = await Swal.fire({
                html: `
                <div>
                  <h5><strong>Enter OTP</strong></h5>
                  <span style="display: block; font-size:16px; text-align: left; margin-bottom: 5px;">
                    One Time Password (OTP)
                  </span>
                  <input id="swal-otp" class="form-control" placeholder="Enter OTP" maxlength="6">
                  <span class="mt-2" style="display: block; font-size:14px; text-align: left; margin-bottom: 5px;">
                    Note: OTP has been sent to your registered phone number.
                  </span>
                </div>
              `,
                confirmButtonText: "Verify OTP",
                showCancelButton: true,
                confirmButtonColor: "#2D7D9F",
                reverseButtons: true,
                preConfirm: () => {
                  const otpValue = document.getElementById("swal-otp").value;
                  if (
                    !otpValue ||
                    otpValue.length !== 6 ||
                    !/^\d+$/.test(otpValue)
                  ) {
                    Swal.showValidationMessage(
                      "Please enter a valid 6-digit OTP"
                    );
                    return false;
                  }
                  return otpValue;
                },
              });

              if (otp) {
                console.log("Entered OTP:", otp);

                const verifyPayload = {
                  subscribed_by: userId,
                  valid_otp: otp,
                  plan_price,
                  account_number,
                  trans_id: trans_id?.toString() || "",
                };
                try {
                  const verifyResponse = await axios.post(
                    NormalVerifyOTP,
                    JSON.stringify(verifyPayload),
                    { headers: HEADERS }
                  );
                  if (verifyResponse?.data?.response_code === "0000") {
                    console.log("resp", verifyResponse);
                    Swal.fire({
                      icon: "success",
                      title: "OTP Verified",
                      text:
                        verifyResponse.data.response_description ||
                        "Subscription completed successfully!",
                      confirmButtonColor: "#2D7D9F",
                    }).then(() => {
                      window.location.reload();
                    });
                  } else {
                    console.log("res", verifyResponse);
                    Swal.fire({
                      icon: "error",
                      title: "OTP Verification Failed",
                      text:
                        verifyResponse.data.response_description ||
                        "Invalid OTP or verification failed.",
                      confirmButtonColor: "#2D7D9F",
                    });
                  }
                } catch (error) {
                  console.error("OTP verification error:", error);
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Something went wrong during OTP verification.",
                    confirmButtonColor: "#2D7D9F",
                  });
                }
              }
            } else {
              console.log("res", response);
              Swal.fire({
                icon: "error",
                title: "Subscription Failed",
                text: response?.data?.message || "Something went wrong!",
                confirmButtonColor: "#2D7D9F",
              });
            }
          } catch (error) {
            console.error("Error during subscription:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong during the subscription request.",
              confirmButtonColor: "#2D7D9F",
            });
          }
        } else if (selectedRank > currentRank) {
          console.log(
            `Consuming SubscriptionUpgrade → from ${subscriptionPlan} to ${plan.plan_name}`
          );

          const requestBody = {
            subscribed_by: userId,
            account_number: accountNumber,
            plan_price: plan.plan_price.toString(),
          };

          console.log("resquest", requestBody);
          try {
            const response = await axios.post(
              SubscriptionUpgrade,
              JSON.stringify(requestBody),
              { headers: HEADERS }
            );
            if (response?.data?.response_code === "0000") {
              const {
                plan_price,
                plan_id: ignoredPlanId,
                account_number,
                trans_id,
              } = response?.data?.data || {};

              const plan_id = plan.plan_id;

              if (!plan_price || !plan_id || !account_number || !trans_id) {
                Swal.fire({
                  icon: "error",
                  title: "Missing Data",
                  text: "Required data missing from server response.",
                  confirmButtonColor: "#2D7D9F",
                });
                return;
              }

              const { value: otp } = await Swal.fire({
                html: `
          <div>
            <h5><strong>Enter OTP</strong></h5>
            <span style="display: block; font-size:16px; text-align: left; margin-bottom: 5px;">
              One Time Password (OTP)
            </span>
            <input id="swal-otp" class="form-control" placeholder="Enter OTP" maxlength="6">
            <span class="mt-2" style="display: block; font-size:14px; text-align: left; margin-bottom: 5px;">
              Note: OTP has been sent to your registered phone number. Also note that you cannot downgrade the plan once you upgrade it.
            </span>
          </div>
        `,
                confirmButtonText: "Verify OTP",
                showCancelButton: true,
                confirmButtonColor: "#2D7D9F",
                reverseButtons: true,
                preConfirm: () => {
                  const otpValue = document.getElementById("swal-otp").value;
                  if (
                    !otpValue ||
                    otpValue.length !== 6 ||
                    !/^\d+$/.test(otpValue)
                  ) {
                    Swal.showValidationMessage(
                      "Please enter a valid 6-digit OTP"
                    );
                    return false;
                  }
                  return otpValue;
                },
              });

              if (otp) {
                console.log("Entered OTP:", otp);

                const verifyPayload = {
                  subscribed_by: userId,
                  valid_otp: otp,
                  plan_price,
                  account_number,
                  trans_id: trans_id.toString(),
                  plan_id,
                };
                console.log("asdf", verifyPayload);
                try {
                  const verifyResponse = await axios.post(
                    UpgradeVerifyOTP,
                    JSON.stringify(verifyPayload),
                    { headers: HEADERS }
                  );

                  if (verifyResponse?.data?.response_code === "0000") {
                    Swal.fire({
                      icon: "success",
                      title: "Upgrade Successful",
                      text:
                        verifyResponse.data.response_description ||
                        "Plan upgraded successfully!",
                      confirmButtonColor: "#2D7D9F",
                    }).then(() => {
                      window.location.reload();
                    });
                  } else {
                    Swal.fire({
                      icon: "error",
                      title: "OTP Verification Failed",
                      text:
                        verifyResponse.data.response_description ||
                        "Invalid OTP or verification failed.",
                      confirmButtonColor: "#2D7D9F",
                    });
                  }
                } catch (error) {
                  console.error("Upgrade OTP verification error:", error);
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Something went wrong during OTP verification.",
                    confirmButtonColor: "#2D7D9F",
                  });
                }
              }
            } else {
              Swal.fire({
                icon: "error",
                title: "Upgrade Failed",
                text:
                  response.data.response_description || "Something went wrong!",
                confirmButtonColor: "#2D7D9F",
              });
            }
          } catch (err) {
            console.error("Upgrade subscription error:", err);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong during subscription upgrade.",
              confirmButtonColor: "#2D7D9F",
            });
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "Downgrade Not Allowed",
            text: "You cannot downgrade your plan.",
            confirmButtonColor: "#2D7D9F",
          });
          return;
        }
      } catch (err) {
        console.error("Subscription error:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong during subscription.",
          confirmButtonColor: "#2D7D9F",
        });
      }
    }
  };

  const displayValue = (planName, value) =>
    planName.toLowerCase() === "enterprise" &&
    (value === null || value === undefined)
      ? "Unlimited"
      : value;

  const getPlanRank = (planName) => {
    const name = planName.toLowerCase();
    if (name === "free") return 1;
    if (name === "pro") return 2;
    if (name === "enterprise") return 3;
    return 0;
  };

  const shouldDisableSubscribeButton = (currentRank, targetRank) => {
    return targetRank < currentRank;
  };

  return (
    <div className="body-main">
      <p className="plan-title">Plans and Pricing</p>
      <div>
        <div className="row">
          <div className="col-md-5 border m-auto rounded ">
            <span className="d-flex justify-content-center ">
              <span className="time-title">Time Remaining</span>
            </span>
            <div className=" d-flex justify-content-between align-items-center">
              <div className="d-flex flex-column align-items-center">
                <span style={{ fontSize: "24px" }}>
                  <strong>{padZero(remainingTime.years)}</strong>
                </span>
                <span className="label">Year</span>
              </div>
              <h2>:</h2>
              <div className="d-flex flex-column align-items-center">
                <span style={{ fontSize: "24px" }}>
                  <strong>{padZero(remainingTime.months)}</strong>
                </span>
                <span className="label">month</span>
              </div>
              <h2>:</h2>
              <div className="d-flex flex-column align-items-center">
                <span style={{ fontSize: "24px" }}>
                  <strong>{padZero(remainingTime.days)}</strong>
                </span>
                <span className="label">day</span>
              </div>
              <h2>:</h2>
              <div className="d-flex flex-column align-items-center">
                <span style={{ fontSize: "24px" }}>
                  <strong>{padZero(remainingTime.hours)}</strong>
                </span>
                <span className="label">hour</span>
              </div>
              <h2>:</h2>
              <div className="d-flex flex-column align-items-center">
                <span style={{ fontSize: "24px" }}>
                  <strong>{padZero(remainingTime.minutes)}</strong>
                </span>
                <span className="label">minute</span>
              </div>
              <h2>:</h2>
              <div className="d-flex flex-column align-items-center">
                <span style={{ fontSize: "24px" }}>
                  <strong>{padZero(remainingTime.seconds)}</strong>
                </span>
                <span className="label">second</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        {plans.map((plan, index) => (
          <div className="col-md-4 pricing-container" key={index}>
            <div className={`feature border rounded`}>
              <h5 className="text-center sub-tit text-uppercase position-relative">
                <strong>{plan.plan_name}</strong>
                {(() => {
                  const currentPlan =
                    remainingTime.subs_plan === 1
                      ? "free"
                      : remainingTime.subs_plan === 2
                      ? "pro"
                      : remainingTime.subs_plan === 3
                      ? "enterprise"
                      : "";
                  return (
                    currentPlan.toLowerCase() ===
                      plan.plan_name.toLowerCase() && (
                      <span
                        className="badge bg-black position-absolute top-0 end-0 m-2"
                        style={{ fontSize: "10px" }}
                      >
                        Current Plan
                      </span>
                    )
                  );
                })()}
              </h5>

              <div className="plans d-flex align-items-center justify-content-center p-2 rounded mt-4 mb-4">
                <span className="price">Nu.{plan.plan_price}</span>
                <span className="mt-2 per-year">
                  {getDurationDisplay(plan)}
                </span>
              </div>
              <span style={{ color: "#505050", fontSize: "14px" }}>
                {getSubtitle(plan.plan_name)}
              </span>
              <div className="horizontal-line">
                <hr />
              </div>
              <h6 className="sub-tit">
                <strong>Feature Difference</strong>
              </h6>
              <div className="d-flex gap-2">
                <h6>&#10004;</h6>
                <h6 style={{ color: "#505050", fontSize: "12px" }}>
                  Max Employee -{" "}
                  {displayValue(plan.plan_name, plan.max_employee)}
                </h6>
              </div>
              <div className="d-flex gap-2">
                <h6>&#10004;</h6>
                <h6 style={{ color: "#505050", fontSize: "12px" }}>
                  Max No. of Department -{" "}
                  {displayValue(plan.plan_name, plan.max_department)}
                </h6>
              </div>
              <button
                className="btn-login mt-4"
                disabled={shouldDisableSubscribeButton(
                  remainingTime.subs_plan,
                  getPlanRank(plan.plan_name)
                )}
                onClick={() => handleSubscribe(plan)}
              >
                Subscribe Plan <span>&#8811;</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Billing;
